import React from 'react';
import Translate from '../shared/localization/localize';
import * as DT from '../../modules/datatable';
import * as DTypes from '../../modules/devicetypes';

export const getColumns = () => {
  const columnDefinitions: DT.TableColumn[] = [
    {
      Header: <Translate message={DTypes.msgDeviceName} />,
      id: 'deviceName',
      accessor: 'deviceName',
      customizable: false,
      defaultShow: true,
    },
    {
      Header: <Translate message={DTypes.msgNumDevices} />,
      id: 'numDevices',
      accessor: 'numDevices',
      customizable: true,
      defaultShow: true,
    },
  ];

  return DT.initColumnsVisibility(columnDefinitions);
};

export default getColumns;
